import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient, ApiError } from "../../lib/api-client";
import { PasswordField } from "../../components/PasswordField";

interface LoginResponse {
  ok: boolean;
  token: string;
  user: {
    id: string;
    username: string;
    role: string;
  };
}

export function AdminLoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await apiClient.post<LoginResponse>("/admin/auth/login", {
        username,
        password,
      });

      if (res.token) {
        localStorage.setItem("datasci_admin_token", res.token);
        localStorage.setItem("datasci_admin_user", JSON.stringify(res.user));
        navigate("/admin");
      }
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Erro ao efetuar login administrativo.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleLogin} className="card">
      <h2>Acesso administrativo</h2>
      <div className="field">
        <label htmlFor="adminUsername">Usuário ou E-mail</label>
        <input
          id="adminUsername"
          type="text"
          required
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="admin ou admin@datasci.com.br"
        />
      </div>

      <PasswordField
        id="adminPassword"
        label="Senha"
        required
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="••••••••"
      />

      {error && <p role="alert" className="notice-error">{error}</p>}

      <button className="btn" type="submit" disabled={loading} style={{ width: "100%", marginTop: "var(--space-3)" }}>
        {loading ? "Entrando..." : "Entrar no Painel Admin"}
      </button>

    </form>
  );
}
